/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { CcrWorklistExQueryReq } from '../models/ccr-worklist-ex-query-req';
import { CcrWorklistExQueryResp } from '../models/ccr-worklist-ex-query-resp';

@Injectable({ providedIn: 'root' })
export class CcrWorklistService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiCcrWorklistQueryPost()` */
  static readonly ApiCcrWorklistQueryPostPath = '/api/ccr/worklist/query';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCcrWorklistQueryPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiCcrWorklistQueryPost$Response(
    params?: {
      body?: CcrWorklistExQueryReq
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<CcrWorklistExQueryResp>>> {
    const rb = new RequestBuilder(this.rootUrl, CcrWorklistService.ApiCcrWorklistQueryPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<CcrWorklistExQueryResp>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCcrWorklistQueryPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiCcrWorklistQueryPost(
    params?: {
      body?: CcrWorklistExQueryReq
    },
    context?: HttpContext
  ): Observable<Array<CcrWorklistExQueryResp>> {
    return this.apiCcrWorklistQueryPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CcrWorklistExQueryResp>>): Array<CcrWorklistExQueryResp> => r.body)
    );
  }

}
